import React from "react";
import { formatNumber2 } from "../../../utils/currencyFormat";

const MiniCard = ({ title, value, iconClass, type, onClick, loading }) => (
  <div
    className="col text-center"
    style={{ cursor: "pointer" }}
    onClick={() => onClick(type, `Chi tiết 1${title}`)}
  >
    <i className={`fas ${iconClass} fa-2x text-gray-400 mb-2`}></i>
    <div
      className="text-xs font-weight-bold text-uppercase mb-1 btn-link"
      style={{ color: "#00B69B" }}
    >
      {title}
    </div>
    {loading ? (
      <div className="spinner-border spinner-border-sm" role="status"></div>
    ) : (
      <div className="h6 mb-0 font-weight-bold text-gray-800">
        {formatNumber2(value)}
      </div>
    )}
  </div>
);
export const SummarySection = ({ data, loading, onItemClick }) => {
  const summaryItems = [
    {
      title: "Tổng Thu Gốc Dự Kiến",
      value: data[0]?.TongTienThuGocDuKien,
      type: "goc",
      icon: "fa-coins",
    },
    {
      title: "Tổng Thu Lãi Dự Kiến",
      value: data[0]?.TongTienThuLaiDuKien,
      type: "lai",
      icon: "fa-percent",
    },
    {
      title: "Tổng Thu Phí Hàng Kỳ Dự Kiến",
      value: data[0]?.TongTienThuPhiHangKyDuKien,
      type: "phi",
      icon: "fa-file-invoice-dollar",
    },
  ];

  const tongThu = summaryItems.reduce(
    (sum, item) => sum + (item.value || 0),
    0
  );

  return (
    <div className="p-2">
      <div className="text-center">
        <h6 className="text-uppercase text-muted">Tổng Thu Dự Kiến</h6>
        {loading ? (
          <div className="spinner-border text-success" role="status"></div>
        ) : (
          <h1 className="font-weight-bold" style={{ color: "#1cc88a" }}>
            {formatNumber2(tongThu)}
          </h1>
        )}
      </div>
      <hr />
      <div className="row">
        {summaryItems.map((item) => (
          <MiniCard
            key={item.type}
            title={item.title}
            value={item.value}
            type={item.type}
            onClick={onItemClick}
            loading={loading}
            iconClass={item.icon}
          />
        ))}
      </div>
    </div>
  );
};
